import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { SelectCallback, Tab } from 'react-bootstrap';
import useAppUser from 'hooks/useAppUser';
import theme from 'styles/theme';
import useFetchAgencyChannelSettings from 'components/domain/channelSettings/useFetchAgencyChannelSettings';
import Badge from 'components/badge/Badge';
import { Channel } from 'models/Channels';
import AnalyticsWrapper from './AnalyticsWrapper';
import HostingQualityWrapper from './HostingQualityWrapper';
import { PageTagsHeaderContainer } from './AnalyticsAndHostingQualityWrapper.styles';
import AnalyticsContextProvider from './AnalyticsContextProvider';
import {
  getAnalyticsFilterLocalStorageKey,
  getChartsFilterLocalStorageKey,
} from './analytics/types/Analytics.constants';

const AnalyticsAndHostingQualityWrapper = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hash } = useLocation();
  const { userUid } = useAppUser();
  const { channelSettings, isFetching: isLoadingChannelSettings } =
    useFetchAgencyChannelSettings(true);

  const isAirbnbActive = !!channelSettings?.find(
    ({ enumId }) => enumId === Channel.airbnb,
  )?.isActive;

  const defaultTabKey = hash ? hash.substring(1) : 'analytics';

  const onSelect: SelectCallback = (eventKey) => {
    const tabKey = eventKey as string | null;

    if (tabKey === 'hosting-quality') {
      navigate('#hosting-quality');
    } else {
      navigate('');
    }
  };

  return (
    <PageTagsHeaderContainer
      defaultActiveKey={defaultTabKey}
      id="analytics-hosting-quality-tabs"
      onSelect={onSelect}
    >
      <div className="divider" />
      <Tab eventKey="analytics" title={t('pageAnalytics.analyticsHeader')}>
        <AnalyticsContextProvider
          analyticsFilterLocalStorageKey={getAnalyticsFilterLocalStorageKey(
            // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            userUid,
          )}
          // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
          chartsFilterLocalStorageKey={getChartsFilterLocalStorageKey(userUid)}
        >
          <AnalyticsWrapper />
        </AnalyticsContextProvider>
      </Tab>
      {isAirbnbActive && !isLoadingChannelSettings && (
        <Tab
          eventKey="hosting-quality"
          title={
            <span>
              {t('pageAnalytics.hostingQualityHeader')}{' '}
              <Badge backgroundColor={theme.colors.hostfullyYellow}>
                {t('pageAnalytics.hostingQualityHeaderBadge')}
              </Badge>
            </span>
          }
        >
          <HostingQualityWrapper />
        </Tab>
      )}
    </PageTagsHeaderContainer>
  );
};

export default AnalyticsAndHostingQualityWrapper;
